import {
  PrimaryButtonLinkProps,
  PrimaryButtonButtonProps,
} from '@/types/props/components';
import clsx from 'clsx';
import { twMerge } from '@/lib/twMerge';
import DefaultButton from './default/DefaultButton';
import DefaultLink from './default/DefaultLink';
import stylesConstants from '@/constants/styles.constants';

const {
  primaryButtonBase,
  primaryButtonNormal,
  primaryButtonOutlined,
  dangerButton,
  dangerButtonOutlined,
  primaryButtonLinkNormalDisabled,
  primaryButtonLinkOutlinedisabled,
  primaryButtonWhite,
  primaryButtonGold,
  primaryButtonOutlinedWhite,
} = stylesConstants.main.buttons;

const PrimaryButton: React.FC<PrimaryButtonButtonProps> = ({
  className: classNameProp = '',
  outlined = false,
  danger = false,
  white = false,
  gold = false,
  ...props
}) => {
  const classNameBase = clsx(primaryButtonBase, {
    [primaryButtonNormal]: !outlined && !danger && !white,
    [primaryButtonOutlined]: outlined && !props.disabled && !danger && !white,
    [primaryButtonLinkOutlinedisabled]:
      outlined && props.disabled && !danger && !white,
    [dangerButton]: danger && !outlined && !props.disabled,
    [dangerButtonOutlined]: danger && outlined && !props.disabled,
    [primaryButtonWhite]: white && !outlined && !danger,
    [primaryButtonGold]: gold && !outlined && !danger,
    [primaryButtonOutlinedWhite]: outlined && white,
  });

  const classNameMerged = twMerge(classNameBase, classNameProp);

  return <DefaultButton {...props} className={classNameMerged} />;
};

const PrimaryButtonLink: React.FC<PrimaryButtonLinkProps> = ({
  disabled = false,
  className: classNameProp = '',
  outlined = false,
  danger = false,
  white = false,
  gold = false,
  ...props
}) => {
  const classNameBase = clsx(`${primaryButtonBase} no-skeleton btn-loading`, {
    [primaryButtonNormal]: !outlined && !disabled && !danger && !white,
    [primaryButtonOutlined]: outlined && !disabled && !danger && !white,
    [primaryButtonLinkNormalDisabled]:
      !outlined && disabled && !danger && !white,
    [primaryButtonLinkOutlinedisabled]:
      outlined && disabled && !danger && !white,
    [dangerButton]: danger && !outlined && !disabled && !white,
    [dangerButtonOutlined]: danger && outlined && !disabled && !white,
    [primaryButtonWhite]: white && !outlined && !disabled && !danger,
    [primaryButtonGold]: gold && !outlined && !disabled && !danger,
    [primaryButtonOutlinedWhite]: outlined && white,
  });

  const classNameMerged = twMerge(classNameBase, classNameProp);

  return <DefaultLink {...props} className={classNameMerged} />;
};

const PrimaryButtonLinkFullRender: React.FC<
  React.ComponentProps<'a'> & { outlined?: boolean; children: React.ReactNode }
> = ({
  className: classNameProp = '',
  outlined = false,
  children,
  ...props
}) => {
  const classNameBase = clsx(primaryButtonBase, {
    [primaryButtonNormal]: !outlined,
    [primaryButtonOutlined]: outlined,
  });

  const classNameMerged = twMerge(classNameBase, classNameProp);

  return (
    <a
      className={twMerge(
        'tw-bg-transparent tw-border-none tw-shadow-none tw-outline-none tw-px-0 tw-py-0 tw-mx-0 tw-my-0 tw-appearance-none focus:tw-outline-none focus:tw-ring-0 tw-text-black tw-text-center tw-no-underline',
        classNameMerged
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export { PrimaryButton, PrimaryButtonLink, PrimaryButtonLinkFullRender };
